export const linkData = [
    {
        url: 'https://mattwdeacon.com/ReactCountdownGame/index.html',
        title: 'Countdown game',
        date: 'Feb. 16, 2024',
        image: './ReactCountdown.jpg',
        description: 'This is a simple timing game created with React, made from a Udemy course by Maximillian Schwartzmuller. The idea is to start a timer and then stop it as close as possible to the time limit. Maximum score is 100 points. This demo makes use of useRef, useState, forwardRef, useImperativeHandle, and createPortal hooks.'
    },
    {
        url: 'https://mattwdeacon.com/ReactTicTacToe/index.html',
        title: 'Tic Tac Toe game',
        date: 'Jan. 5, 2024',
        image: './TicTacToe.jpg',
        description: 'This is a simple Tic Tac Toe game created with React, made from a Udemy course by Maximillian Schwartzmuller. Features include the ability to change player names, take alternating turns picking squares, a log of the turns taken (below the board), and a popup that shows victory or a draw, with a button to reset and play again.'
    },
    {
        url: 'http://mattwdeacon.com/ReactFilmGallery/index.html',
        title: 'Media Gallery',
        date: 'Dec. 28, 2023',
        image: './filmgallerythumb.jpg',
        description: 'This is a search-driven, simple gallery opf title cards for films, TV shows, and video games, with details drawn from the Online Internet Movie Database. This was created via a React tutorial, but I added some additional functionality - for example, the OMDB API only returns the first 10 matches, so I added pagination to be able to search for additional matches beyond those.  Note, however, that the OMDB API seems to respond slower the further you go into the results, so if you jump straight to page 80 or some such, you may be waiting a while... or even see a timeout.'
    },
    {
        url: 'https://mattwdeacon.com/portfolio/semidnd.com/index.html',
        title: 'SemiDND',
        date: 'September 2013',
        image: './semidnd_thumb.jpg',
        description: 'A multi-page web site built for my Dungeons and Dragons group. Use "Guest" for the first and last name to pass the gatekeeper.  This is a dummy copy of the actual site, and has not been updated since its inception.'
    },
    {
        url: 'https://mattwdeacon.com/polyRPG/polyRPG.html',
        title: 'PolyRPG',
        date: 'November 9, 2013',
        image: './polyrpg_thumb.jpg',
        description: "Built with Bootstrap, this site is an online version of an original rule set that I created for tabletop roleplaying games. This rule set requires a common set of polyhedral dice (4-, 6-, 8-, 10- 12- and 20-sided dice). The twist is that characters' attributes are directly tied to the dice--a higher attribute lets the character roll bigger dice when trying to accomplish something."
    }
]